module.exports = __webpack_public_path__ + "img/m_11.98257cab.png";